import { styled } from '@mui/material/styles';
import { useInterstateTheme } from '../../InterstateThemeProvider';
import { baseStyles } from '../../common/baseStyles';
import { jsx as _jsx } from "react/jsx-runtime";
export const StyledInverseButton = _ref => {
  let {
    onClick,
    children,
    id,
    className,
    actionType,
    ...rest
  } = _ref;
  const theme = useInterstateTheme();
  const StyledButton = styled('button')(_ref2 => {
    let {
      theme,
      type
    } = _ref2;
    return {
      display: 'inline-flex',
      justifyContent: 'center',
      alignItems: 'center',
      boxSizing: 'border-box',
      backgroundColor: 'transparent',
      color: theme.tokens.ComponentSnackbarColorButton,
      background: 'none',
      outline: 'none',
      border: '0',
      borderRadius: '4px',
      margin: '0',
      padding: '8px',
      cursor: 'pointer',
      fontWeight: 500,
      ':hover': {
        background: actionType === 'action' ? theme.tokens.ComponentSnackbarColorHoverBackground : 'transparent'
      },
      ...baseStyles
    };
  });
  return /*#__PURE__*/_jsx(StyledButton, {
    onClick: onClick,
    type: 'button',
    "data-testid": rest['data-testid'],
    id: id,
    children: children
  });
};